import { useEffect, useState } from 'react';

import { exchangeInitData } from '@/api/client';
import { getAccessToken } from '@/lib/auth';
import type { StudentMe } from '@/types/api';

interface AuthState {
  status: 'pending' | 'authed' | 'error';
  user?: StudentMe;
  error?: string;
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ status: 'pending' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // If we already have a token (e.g. from a hot reload), try it first.
        if (getAccessToken()) {
          setState({ status: 'authed' });
          return;
        }
        const resp = await exchangeInitData();
        if (!cancelled) setState({ status: 'authed', user: resp.user });
      } catch (err) {
        if (!cancelled) {
          setState({
            status: 'error',
            error: err instanceof Error ? err.message : String(err),
          });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
